import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const BouncesPage = lazy(() => import('../pages/bounces/page'));
const InteractivePage = lazy(() => import('../pages/interactive/page'));
const EntertainmentPage = lazy(() => import('../pages/entertainment/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServiceAreasPage = lazy(() => import('../pages/service-areas/page'));
const ReviewsPage = lazy(() => import('../pages/reviews/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/bounce-house-rentals',
    element: <BouncesPage />,
  },
  {
    path: '/interactive-activities',
    element: <InteractivePage />,
  },
  {
    path: '/entertainment',
    element: <EntertainmentPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/service-areas',
    element: <ServiceAreasPage />,
  },
  {
    path: '/reviews',
    element: <ReviewsPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;